import * as React from 'react';
import ReactDiffViewer from 'react-diff-viewer';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import '../../../../../modal.css';
import { StringColumn, CustomColumn } from 'baseui/data-table';
import { Button } from 'baseui/button';
import { ConfirmationModal, Loader, ETournamentCsvStatus } from 'commons-ui';
import useDashboardActions from 'pages/dashboard/useDashboardActions';
import useList from './useList';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import { CTournamentDiffModelStyle } from '../../utils/constants';

export const COL_NAMES = {
	PREV_CSV: 'previousCsv',
	CURR_CSV: 'currCsv'
};

export const TournamentListConfig = () => {
	const {
		handleRollback,
		confirmation,
		confirmationDialogOnAgree,
		confirmationDialogOnClose,
		rollbackData,
		docId,
		showLoader,
		handleApproval,
		approvalConfirmation,
		approvalConfirmationDialogOnClose,
		approvalConfirmationDialogOnAgree,
		csvForApprovaldocId
	} = useList();
	const { getActionList } = useDashboardActions(makeActionHandler, makeActionList);
	const rollbackItems = getActionList();
	const isRollbackAllowed =
		rollbackItems.rollbackAction.isEnabled()?.rollbackTournamentFile === true ||
		rollbackItems.rollbackAction.isEnabled() === true;
	return [
		CustomColumn({
			title: 'Download Link / Get Diff',
			maxWidth: 200,
			minWidth: 100,
			mapDataToValue: (data: any) => {
				return {
					url: data[COL_NAMES.PREV_CSV].url,
					preProd: data[COL_NAMES.PREV_CSV].preProd,
					newCsvData: data[COL_NAMES.PREV_CSV].newCsvData,
					oldCsvData: data[COL_NAMES.PREV_CSV].oldCsvData
				};
			},
			renderCell: (params: any) => {
				const { value } = params;
				if (!value.preProd) {
					return (
						<a href={value.url} download>
							Download here
						</a>
					);
				}
				return value.preProd ? (
					<Popup
						trigger={
							<Button type='button' size='mini'>
								Get Diff
							</Button>
						}
						position='center center'
						modal
						closeOnDocumentClick
						contentStyle={CTournamentDiffModelStyle}>
						{(close: any) => (
							<div className='modal'>
								<button className='close' onClick={close} type='button'>
									&times;
								</button>
								<div className='header'>
									{' '}
									Pre Prod Csv Diff{' '}
									<a href={value.url} download>
										Download Csv
									</a>{' '}
								</div>
								<div className='content'>
									<ReactDiffViewer oldValue={value.oldCsvData} newValue={value.newCsvData} splitView={false} />
								</div>
							</div>
						)}
					</Popup>
				) : (
					<p> </p>
				);
			}
		}),
		CustomColumn({
			title: 'Path',
			maxWidth: 300,
			mapDataToValue: (data: any) => {
				return {
					path: data[COL_NAMES.PREV_CSV]?.path,
					mainFile: data[COL_NAMES.PREV_CSV]?.mainFile,
					preProd: data[COL_NAMES.PREV_CSV]?.preProd
				};
			},
			renderCell: (params: any) => {
				const { value } = params;
				if (value.mainFile) {
					return (
						<p>
							<b>{value.path} (live)</b>
						</p>
					);
				}
				if (value.preProd) {
					return (
						<p>
							<b>{value.path} (pre-prod)</b>
						</p>
					);
				}
				return <p>{value.path}</p>;
			}
		}),
		CustomColumn({
			title: 'Logs',
			mapDataToValue: (data: any) => data[COL_NAMES.PREV_CSV]?.logs,
			renderCell: (params: any) => {
				const { value } = params;
				return value && value.steps ? (
					<Popup
						trigger={
							<Button type='button' size='mini'>
								Click to view
							</Button>
						}>
						{(close: any) => (
							<div className='modal'>
								<button className='close' onClick={close} type='button'>
									&times;
								</button>
								<div className='header'> Execution logs </div>
								<div className='content'>
									{value.steps.map((ele: any) => {
										return <div>{ele}</div>;
									})}
								</div>
							</div>
						)}
					</Popup>
				) : (
					<p> </p>
				);
			}
		}),
		StringColumn({
			title: 'User',
			maxWidth: 300,
			mapDataToValue: (data: any) => (data[COL_NAMES.PREV_CSV]?.user ? data[COL_NAMES.PREV_CSV]?.user : '')
		}),
		StringColumn({
			title: 'Created At',
			maxWidth: 300,
			mapDataToValue: (data: any) => JSON.stringify(data[COL_NAMES.PREV_CSV]?.createdAt)
		}),
		StringColumn({
			title: 'Deployment Started At',
			maxWidth: 300,
			mapDataToValue: (data: any) => JSON.stringify(data[COL_NAMES.PREV_CSV]?.startTime)
		}),
		StringColumn({
			title: 'Deployment Ended At',
			maxWidth: 300,
			mapDataToValue: (data: any) => JSON.stringify(data[COL_NAMES.PREV_CSV]?.endTime)
		}),
		StringColumn({
			title: 'Execution Time (Sec)',
			maxWidth: 300,
			mapDataToValue: (data: any) => JSON.stringify(data[COL_NAMES.PREV_CSV]?.executionTime)
		}),
		StringColumn({
			title: 'Status',
			maxWidth: 100,
			mapDataToValue: (data: any) => (data[COL_NAMES.PREV_CSV]?.status ? data[COL_NAMES.PREV_CSV]?.status : '')
		}),
		CustomColumn({
			title: 'Rollback / Approve',
			maxWidth: 300,
			mapDataToValue: (data: any) => {
				return {
					gameName: data[COL_NAMES.PREV_CSV]?.gameName,
					docId: data[COL_NAMES.PREV_CSV]?.docId,
					mainFile: data[COL_NAMES.PREV_CSV]?.mainFile,
					user: data[COL_NAMES.PREV_CSV]?.user,
					path: data[COL_NAMES.PREV_CSV]?.path,
					preProd: data[COL_NAMES.PREV_CSV].preProd,
					status: data[COL_NAMES.PREV_CSV].status,
					iAmApprover: data[COL_NAMES.PREV_CSV].iAmApprover
				};
			},
			renderCell: (params: any) => {
				const { value } = params;
				const emptyParaMsg = !isRollbackAllowed ? 'Insufficient permission' : '';
				const iAmNotApproverMsg: string = 'Insufficent permission';
				if (
					!value.mainFile &&
					!value.preProd &&
					value.docId &&
					isRollbackAllowed &&
					value.status !== ETournamentCsvStatus.FAILED
				) {
					return (
						<>
							<Button type='button' size='mini' onClick={() => handleRollback(value)}>
								Rollback
							</Button>
							{confirmation && value.docId === docId && (
								<ConfirmationModal
									confirmationHeader='Are you sure want to rollback ?'
									confirmationMessage={`You are about to rollback previous csv\n${rollbackData}, this action will go for approval`}
									onClose={confirmationDialogOnClose}
									confirmationDialogOnAgree={() => confirmationDialogOnAgree(value)}
								/>
							)}
							{showLoader && value.docId === docId && <Loader />}
						</>
					);
				}
				if (
					!value.mainFile &&
					value.preProd &&
					value.docId &&
					value.iAmApprover &&
					value.status === ETournamentCsvStatus.WAITING
				) {
					return (
						<>
							<Button type='button' size='mini' onClick={() => handleApproval(value)}>
								Approve
							</Button>
							{approvalConfirmation && value.docId === csvForApprovaldocId && (
								<ConfirmationModal
									confirmationHeader='Are you sure want to approve ?'
									confirmationMessage='On approval, this csv will be live in next few seconds'
									onClose={approvalConfirmationDialogOnClose}
									confirmationDialogOnAgree={() => approvalConfirmationDialogOnAgree(value)}
								/>
							)}
							{showLoader && value.docId === csvForApprovaldocId && <Loader />}
						</>
					);
				}
				if (!value.mainFile && value.preProd && value.docId && !value.iAmApprover) {
					return <p>{iAmNotApproverMsg}</p>;
				}
				return <p>{emptyParaMsg}</p>;
			}
		})
	];
};
